import type { IAttachment } from "@/lib/InterfacesAndTypes"

export type AttachmentDisplayKind =
	| "pdf"
	| "doc"
	| "ppt"
	| "xls"
	| "csv"
	| "image"
	| "text"
	| "other"

const IMAGE_EXTENSIONS = new Set([
	"jpg",
	"jpeg",
	"png",
	"gif",
	"webp",
	"bmp",
	"svg",
	"ico",
	"tiff",
	"tif",
	"heic",
	"heif",
])

function extensionFromFilename(filename: string) {
	const i = filename.lastIndexOf(".")
	if (i < 0) {
		return ""
	}
	return filename.slice(i + 1).toLowerCase()
}

export function getAttachmentDisplayKind(attachment: Pick<IAttachment, "fileType" | "filename">): AttachmentDisplayKind {
	const ft = (attachment.fileType || "").toLowerCase()
	const mime = ft.includes("/") ? ft : ""
	const typeExt = ft.includes("/") ? "" : ft
	const ext = extensionFromFilename(attachment.filename || "") || typeExt

	if (mime === "application/pdf" || ext === "pdf") {
		return "pdf"
	}
	if (mime.startsWith("image/") || IMAGE_EXTENSIONS.has(ext)) {
		return "image"
	}
	if (mime.startsWith("text/") || ext === "txt" || ext === "csv") {
		if (ext === "csv" || mime === "text/csv") {
			return "csv"
		}
		return "text"
	}
	if (
		mime.includes("wordprocessingml")
		|| mime === "application/msword"
		|| ext === "doc"
		|| ext === "docx"
	) {
		return "doc"
	}
	if (
		mime.includes("spreadsheetml")
		|| mime === "application/vnd.ms-excel"
		|| ext === "xls"
		|| ext === "xlsx"
	) {
		return "xls"
	}
	if (
		mime.includes("presentationml")
		|| mime === "application/vnd.ms-powerpoint"
		|| ext === "ppt"
		|| ext === "pptx"
	) {
		return "ppt"
	}
	if (ext === "csv") {
		return "csv"
	}
	return "other"
}
